import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import NetsuiteData from '../types/NetsuiteData'

export const mutations: MutationTree<NetsuiteData> = {
  [types.NETSUITE_CUSTOMER] (state, customer) {
    state.customer = customer
  },
  [types.NETSUITE_ORDERS] (state, orders) {
    state.orders = orders
  },
  [types.NETSUITE_ORDER_SUMMARIES] (state, orderSummaries) {
    state.orderSummaries = orderSummaries
  },
  [types.NETSUITE_CURRENT_ORDER] (state, order) {
    state.currentOrder = order
  },
  [types.NETSUITE_ORDER_ITEMS] (state, orderItems) {
    state.orderItems = orderItems
  },
  [types.NETSUITE_TRACKING] (state, tracking) {
    state.tracking = tracking
  },
  [types.NETSUITE_LOADING] (state, loading: boolean) {
    state.loading = loading
  },
  [types.NETSUITE_SUBMITTING] (state, submitting: boolean) {
    state.submitting = submitting
  },
  [types.NETSUITE_ERROR] (state, error: string | null) {
    state.error = error
  },
  [types.NETSUITE_CLEAR] (state) {
    state.customer = null
    state.orders = null
    state.orderSummaries = null
    state.currentOrder = null
    state.orderItems = null
    state.tracking = null
    state.loading = false
    state.submitting = false
    state.error = null
  }
}
